var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module h-full flex px-4 py-0"},[_c('pipeline',{staticClass:"w-1/3",attrs:{"opportunity":true}}),_c('separator',{attrs:{"direction":'vertical'}}),_c('opportunities-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }